export class ChartBarOptions
{
    public static id = 'bar';
    public static fill = false;

    public static getOptions() : any {

        return {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false,
            },
            scales: {
                // The following will affect the vertical lines (xAxe) of your dataset
                xAxes: [{
                    barPercentage: 0.4,
                    offset: false,
                    gridLines: {
                        // You can change the color, the dash effect, the main axe color, etc.
                        borderDash: [2, 2],
                        color: "#363b6d",
                        offsetGridLines: false,
                        display: false
                    },

                }],

                // And this will affect the horizontal lines (yAxe) of your dataset
                yAxes: [{
                    gridLines: {
                        borderDash: [2, 2],
                        color: "#363b6d",
                        zeroLineWidth: 1,
                        zeroLineColor: '#363b6d',
                        zeroLineBorderDashOffset: 0.0,
                        display: false
                    },
                }],
            },
            tooltips: {
              enabled: false
            }
        }
    };

    public static getAdditionalData() : any{
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/model/options-type/chart-bar-options.ts